"use client";

import { useTranslations } from "next-intl";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link } from "@/i18n/navigation";
import { chapterNumeralSx } from "@/theme/tokens";
import { PageTopBar } from "@/components/layout/PageTopBar";
import { Footer } from "@/components/landing/Footer";

/**
 * Branded 404 for paths under a valid locale. Renders inside the locale layout,
 * so it inherits the theme, fonts, and provider; the shared top bar and footer
 * keep it looking like every other sub-page.
 */
export default function NotFound() {
  const t = useTranslations("notFound");
  return (
    <>
      <PageTopBar />
      <Box component="main" id="main-content">
        <Container
          maxWidth="sm"
          sx={{ py: { xs: 12, md: 18 }, textAlign: "center" }}
        >
          <Typography
            variant="h1"
            sx={{ ...chapterNumeralSx, fontSize: "clamp(4.5rem, 12vw, 8rem)", mb: 2 }}
          >
            404
          </Typography>
          <Typography variant="h2" sx={{ fontSize: "1.5rem", mb: 2 }}>
            {t("title")}
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 4 }}>
            {t("description")}
          </Typography>
          <Button component={Link} href="/" variant="contained" size="large">
            {t("cta")}
          </Button>
        </Container>
      </Box>
      <Footer />
    </>
  );
}
